import { useContext } from "react";
import { DataContext } from "../../store/data-context";
import ContactForm from "./ContactForm";
import styles from "./Header.module.css";
const Header = () => {
  const { headerImages } =
    useContext(DataContext);
  const { logo, headerBackground, faceOfHeader } =
    headerImages;

  return (
    <section
      className={styles.header}
      style={{
        backgroundImage: `url(${headerBackground})`,
      }}
    >
      <section
        className={styles["header__section1"]}
      >
        <img src={logo} alt="logo" />
        <h2 id={styles.phone_number}>
          +1-959-200-777
        </h2>
      </section>
      <section
        className={styles["header__section2"]}
      >
        <img
          src={faceOfHeader}
          alt="face of header"
          id={styles["face-of-header"]}
        />
        <ContactForm />
      </section>
    </section>
  );
};

export default Header;
